import React, { Component } from "react";
import { connect } from "react-redux";
import BaseBooleanField from '../../Base/ui/inputs/BooleanField'

class BooleanField extends Component {
  handleChange(option) {
    const value = option === null ? null : option.value;
    this.props.handleUpdateResident(this.props.name, value);
  }

  render() {
    const { resource, name, label, col, action, value } = this.props;
    return(
      <BaseBooleanField 
        resource={resource}
        name={name}
        label={label}
        col={col}
        value={value}
        action={action}
        onChange={this.handleChange.bind(this)}/>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { resource = "resident", name } = ownProps;

  return {
    action: ownProps.action || state.ui.action,
    value: state[resource][name]
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleUpdateResident: (name, value) => dispatch({ type: "UPDATE_RESIDENT", payload: { name, value }})
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BooleanField);
